/* eslint-disable */

/**
 * @param {Array} arr 需要被初始化的数组
 * @param {any} parent 递归传递的上一个数组
 */
function initAdminTree(arr, parent?: []) {
  arr.forEach((v, i, t) => {
    const { remark, authority, parameters, type, url, verify, id, display } = v;
    const temp = {
      text: remark,
      name: authority,
      parameters: parameters || "",
      type,
      url,
      verify,
      id,
      display,
      status: true,
      treeIndex: parent ? `${parent.treeIndex},${authority}` : `${authority}`,
    };
    t[i] = temp;
    if (v.children) {
      t[i].children = v.children;
      initAdminTree(v.children, t[i]);
    }
  });
}

/**
 *
 *
 * @param {any} tree 被查找的深层对象数组
 * @param {any} treeIndex 查找的treeIndex字段
 * @returns 返回查找到的节点
 */
function getTreeIndex(tree, treeIndex) {
  const indexs = treeIndex.split(",");
  let node;
  indexs.forEach((v, i) => {
    if (i) {
      node = node.children.find((k) => k.name === v);
    } else {
      node = tree.find((k) => k.name === indexs[i]);
    }
  });
  return node;
}

export { initAdminTree, getTreeIndex };
